import BaseAPI from './base';

class GoalcardService extends BaseAPI {
  getGoalcard = async (goalcardId) => {
    const url = `/GoalcardsMin/${goalcardId}`;
    return this.getJson(url);
  };

  getAffiliateGoalcard = async (affiliateCode) => {
    const url = `/affiliates/${affiliateCode}/goalcard`;

    return this.getJson(url);
  }

  getContactAffiliateGoalcard = async (contactAffiliateCode) => {
    const url = `/AffiliateContacts/${contactAffiliateCode}/goalcard`;

    return this.getJson(url);
  }

  createGoalcard = async (payload) => {
    const url = '/CC-Goalcards';
    return this.postJson(url, payload);
  }
}

export default new GoalcardService();
